import { ref } from 'vue';
import { createPopper } from '@popperjs/core';

const usePopper = () => {
    const _popper = ref();
    const initPopper = (reference, popper, options) => {
        _popper.value = createPopper(reference, popper, options);
    };
    const destroyPopper = () => {
        if (_popper.value) {
            _popper.value.destroy();
        }
        _popper.value = undefined;
    };
    return {
        popper: _popper.value,
        initPopper,
        destroyPopper,
    };
};

export { usePopper };
//# sourceMappingURL=usePopper.js.map
